/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import InternationalizationStore from '../../../store/internationalization-store.js'
import { FormControl , FormGroup } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import InternationalisationStore from '../../../store/internationalization-store.js';
export default {
    name: <FormattedMessage id={ 'ui-452' } defaultMessage={ 'Class Name' }/>,
    title:null,
    onSubmit: function (done){

        if(!this.props.data.name){
            return done(new Error(InternationalizationStore.getTranslation('ui-902' ,'Please Enter A Class Name' )));
        }
        else
        {
            ClassService.doesNameExist(this.props.data.name).then(function(isValid){
                if(isValid) return  done();
                else done(new Error(InternationalizationStore.getTranslation('ui-901' ,'You all ready have a class with that name' )));
            })
        }
    },
    component:  React.createClass({
        handelClassNameChange: function(e){
            this.props.data.name = e.target.value;
        },
        render: function(){
            return  <FormGroup className="fg-line fg-toggled">
                        <FormControl autoFocus  placeholder={InternationalisationStore.getTranslation('ui-902' , 'Please enter class enter')} type="text" onChange={this.handelClassNameChange}/>
                    </FormGroup>
        }
    })
}


// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/class-name.js